import { InjectionToken } from '@angular/core';
import { SentryErrorHandler } from '@sentry/angular-ivy';

export interface SentryConfiguration {
  apiUrl: string;
  dsn: string;
  environment: 'QA' | 'UAT' | 'PROD';
  release: string;
}

export const SENTRY_ERROR_LOGGER = new InjectionToken<SentryErrorHandler>('SENTRY_ERROR_LOGGER');
